import { Button, Card, Col, Row, Typography, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import fbaLogo from '../../../assets/fbaLogo.png';

function FBA({ hasCredentials }) {
  const { t } = useTranslation();
  const { Text } = Typography;

  return (
    <Card
      style={{
        borderRadius: '10px',
        marginBottom: '18px',
      }}
      className="courierAvatarCard"
    >
      <Row style={{ width: '100%', display: 'flex' }}>
        <Col style={{ marginRight: 0 }}>
          <Card
            style={{ width: 100, textAlign: 'center' }}
            className="courierAvatarImageCard"
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '90px',
              }}
            >
              <img
                width="90px"
                src={fbaLogo}
                style={{ padding: '10px' }}
                alt={`img_${'Fulfillment By Amazon'}`}
              />
            </div>
          </Card>
        </Col>

        <Col
          flex="1"
          style={{
            display: 'flex',
            alignItems: 'center',
            marginLeft: '20px',
            marginRight: '20px',
            minWidth: 0,
            gap: 8,
            overflow: 'hidden',
          }}
        >
          <Text
            style={{
              fontSize: '16px',
            }}
          >
            Fulfillment By Amazon
          </Text>

          <Tooltip title={t('logistics.tooltip.FBA')}>
            <InfoCircleOutlined />
          </Tooltip>
        </Col>

        <Col
          style={{
            display: 'flex',
            alignItems: 'center',
            marginLeft: 'auto',
          }}
        >
          <Button
            style={{
              backgroundColor: hasCredentials ? '#33BA6A' : '#CACACA',
              color: hasCredentials ? 'white' : 'black',
              pointerEvents: 'none',
              width: '130px',
              height: '42px',
            }}
            className={
              hasCredentials ? 'courierConnected' : 'courierNotConnected'
            }
          >
            {hasCredentials ? 'Conectado' : 'No conectado'}
          </Button>
        </Col>
      </Row>
    </Card>
  );
}

FBA.propTypes = {
  hasCredentials: PropTypes.bool,
};

FBA.defaultProps = {
  hasCredentials: false,
};

export default FBA;
